import 'bender-url!../img/logo/connect-app-icon.png';
import 'bender-url!../img/logo/connect-infinity-icon-themed.svg';
import App from './App';
new App().start();